<template>
    <loading-content v-if="loading" :width="810" :height="80" />
    <div v-else class="vehicle-header d-flex px-2 mb-2 mb-md-0">
        <div class="img-container mr-3">
            <vehicle-image :src="imageUrl" :stock-src="stockImageUrl" :body-style="bodyStyle" :alt="vehicleName" />
        </div>
        <div class="vehicle d-flex flex-column">
            <span class="ymm-title font-weight-bold">
                {{ vehicleYear }} {{ vehicleMake }}
                {{ vehicleModel }}
            </span>
            <span class="trim">
                {{ trim }}
            </span>
            <span class="vin"> VIN: {{ vin }} </span>
            <span class="color"> Color: {{ exteriorColor }} </span>
            <div v-if="contractId" class="confirmation pt-2">
                <span class="font-italic">{{ contractIdLabel }}: </span>
                <span class="font-weight-bold">{{ contractId }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import VehicleImage from "Components/VehicleImage";
import api from "@/api";
import LoadingContent from "Components/LoadingContent";
import lodashGet from "lodash/get";
import lodashIsNil from "lodash/isNil";

export default {
    components: { LoadingContent, VehicleImage },
    props: {
        dealId: {
            type: Number,
            required: false,
            default: null,
        },
        vehicleId: {
            type: String,
            required: false,
            default: null,
        },
        contractId: {
            type: Number,
            required: false,
            default: null,
        },
        contractIdLabel: {
            type: String,
            required: false,
            default: "Order #",
        },
    },
    data() {
        return {
            loading: true,
            vehicle: null,
        };
    },
    computed: {
        bodyStyle() {
            const bodyStyle = lodashGet(this.vehicle, "bodyStyle", null);
            return lodashIsNil(bodyStyle) ? "sedan" : bodyStyle;
        },
        imageUrl() {
            return lodashGet(this.vehicle, "imageUrl");
        },
        stockImageUrl() {
            return lodashGet(this.vehicle, "stockImageUrl");
        },
        vehicleYear() {
            return lodashGet(this.vehicle, "year");
        },
        vehicleMake() {
            return lodashGet(this.vehicle, "make");
        },
        vehicleModel() {
            return lodashGet(this.vehicle, "model");
        },
        trim() {
            return lodashGet(this.vehicle, "trim");
        },
        vin() {
            return lodashGet(this.vehicle, "vin");
        },
        exteriorColor() {
            return lodashGet(this.vehicle, "exteriorColor");
        },
        vehicleName() {
            return this.vehicleYear + " " + this.vehicleMake + " " + this.vehicleModel;
        },
    },
    mounted() {
        this.fetchVehicle();
    },
    methods: {
        fetchVehicle() {
            if (!lodashIsNil(this.dealId)) {
                api.get(`/deals/${this.dealId}/vehicle`)
                    .then((response) => {
                        this.vehicle = response.data;
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.loading = false;
                    });
            } else if (!lodashIsNil(this.vehicleId)) {
                api.get(`/vehicles/${this.vehicleId}/header`)
                    .then((response) => {
                        this.vehicle = response.data;
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.loading = false;
                    });
            }
        },
    },
};
</script>
<style lang="scss">
.vehicle-header {
    border-radius: 2px;

    .img-container {
        height: 68px;
        width: 103px;
        min-width: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .vehicle {
        .ymm-title {
            color: $gray-800;
            font-size: px2rem(14);
            font-weight: bold;
        }
        .trim {
            color: $black;
            font-size: px2rem(12);
            letter-spacing: 0;
            line-height: 14px;
        }
        .vin,
        .color {
            font-size: px2rem(10);
            line-height: 12px;
        }
        .confirmation {
            font-size: px2rem(10);
            font-weight: bold;
            letter-spacing: 0;
            line-height: 12px;
        }
    }
}
.button-box {
    padding: 0;
    width: 100%;

    @include media-breakpoint-up(md) {
        width: unset;
        position: absolute;
        right: 35px;
    }
}
</style>
